import { DashboardVehicleInventoryTable } from "./Table";


const DashboardVehicleInventory = () => {
    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <DashboardVehicleInventoryTable />
        </div>
    );
};

export default DashboardVehicleInventory;
